import useGrpc from "./grpc.js";
import app from "./app";
const grpc = useGrpc();

let routes = {};

export function route(path, action) {
  routes[path] = action;
}

function resolveRoute(urlPath) {
  if (urlPath in routes) {
    return routes[urlPath];
  }

  for (let part of urlPath.split("/")) {
    if (part in routes) {
      return routes[part];
    }
  }

  return () => undefined;
}

export function router(evt) {
  const routeResolved = resolveRoute(window.location.pathname);
  routeResolved();
}

// will route to the destination if the user is not already on the
// page and user data exist for the user. Otherwise, it will route
// to the signup page to force the user to update the required
// user information
export const loggedInRouteTo = (path) => {
  grpc.getUserData().then((data) => {
    if (!data) {
      window.location.replace(app.signup);
      return;
    }

    if (!window.location.pathname === path) window.location.replace(path);
  });
};

export default {};
